<div
  *ngIf="dataIsLoaded"
  data-theme="dark"
  [ngStyle]="{ 'background-color': data.color === 'black' ? 'white' : 'black' }"
>
  <img
    [src]="data.background"
    srcset="{{data.mobileBackground ? data.mobileBackground + ' 644w,' : ''}} {{data.background}}"
    sizes="(max-width: 644px) 644px, 1400px"
    class="hero-image img-fluid"
    alt=""
  />
  <div *ngIf="data.background" class="hero">
    <div class="hero-inner">
      <div class="hero-content container {{ data.alignment ? 'text-' + data.alignment : 'text-center' }}">
        <div
          class="hero-text {{ marketIn('zhs-CN') && src === 'hero-give-back' ? 'hero-text-cn' : '' }}"
          [innerHTML]="data.text"
          [ngStyle]="{ color: data.color }"
        ></div>

        <div class="hero-link" *ngIf="hasInnerText(data.linkText) && !marketIn('zhs-CN')">
          <a
            href="{{ data.linkUrl }}"
            attr.data-automation="{{ urlPathId(data.linkUrl) }}"
            target="{{ data.target }}"
            class="btn btn-ghost btn-{{ data.color }}"
            [innerHTML]="data.linkText"
            [attr.data-id]="data.linkUrl"
            attr.data-name="{{ src + '.campaign' | i18n : 'usanadotcom' }}"
            [attr.data-creative]="data.background"
            [attr.data-position]="src"
            inViewport
            (inViewportAction)="captureView($event)"
            (click)="captureClick($event)"
          ></a>
        </div>

        <!-- change in China -->
        <div class="hero-link hero-modal" *ngIf="marketIn('zhs-CN') && src === 'hero-give-back'">
          <a
            href="javaScript:void(0);"
            (uClickOutside)="toggle($event)"
            id="100"
            class="btn btn-blue"
            [ngClass]="curState ? 'btn-clicked' : ''"
            [innerHTML]="data.linkText"
          ></a>
          <div class="hero-qr" [ngStyle]="{ display: curState ? 'block' : 'none' }" id="101">
            <img src="assets/zh-CN/images/give-back/donateQr.jpg" id="102" alt="" />
            <p class="qr-title" [innerHTML]="data.qrTitle" id="103"></p>
          </div>
        </div>

        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div class="container disclaimer" [innerHTML]="data.disclaimer"></div>
</div>
